// @core/api/endpoints/team/accept_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcceptRoleDelegationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Accept delegation as delegate
 * Performs accept operation on role delegation.
 */
export async function AcceptRoleDelegation(
  team_id: string,
  delegation_id: string,
  data: AcceptRoleDelegationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id/accept`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
